import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-5, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconChart5"><path d="M9.33008 3.00098V21.001H14.6601V3.00098H9.33008Z" fill="currentColor"/><path d="M3 13.001V21.001H8.33V13.001H3Z" fill="currentColor"/><path d="M15.6602 21.001V8.00098H20.9902V21.001H15.6602Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart5;
